import { createSlice, PayloadAction } from '@reduxjs/toolkit';
import { CreditScore } from 'src/types/inputs';

export type UserDataReducer = {
  isReturnUser: boolean;
  isSignedIn: boolean;
  tuCreditScore: number | null;
  tuCreditScoreBand: CreditScore | null;
  inputs?: Record<string, any>;
  userEmail: string;
  analytics?: {
    pageName: string;
    pageImpressionID: string;
    pagePath: string;
  };
};

const initialState: UserDataReducer = {
  isReturnUser: false,
  isSignedIn: false,
  tuCreditScore: null,
  tuCreditScoreBand: null,
  userEmail: '',
  analytics: {
    pageName: '',
    pageImpressionID: '',
    pagePath: '',
  },
};

const userData = createSlice({
  name: 'userData',
  initialState,
  reducers: {
    signIn(state, action: PayloadAction<boolean>) {
      state.isSignedIn = action.payload;
    },
    updateUserEmail(state, action: PayloadAction<string>) {
      state.userEmail = action.payload;
    },
    updateSignupAnalytics(
      state,
      action: PayloadAction<UserDataReducer['analytics']>
    ) {
      state.analytics = action.payload;
    },
  },
});

export const { signIn, updateUserEmail, updateSignupAnalytics } =
  userData.actions;
export default userData.reducer;
